<template>
  <tr>
    <td>
      {{order_entry.shop_host}}
    </td>
    <td>
      {{order_entry.ordertime}}
    </td>
    <td>
        {{order_entry.ordernumber}}
    </td>
    <td>
        {{order_entry.status_text}}
    </td>
    <td>
        {{order_entry.cleared_text}}
    </td>
    <td>
      {{order_entry.customernumber}}
    </td>
    <td>
      {{order_entry.billing_last_name}}
      {{order_entry.billing_first_name}}
    </td>
    <td>
      {{order_entry.order_item.name}}
    </td>
    <td>
      {{order_entry.order_item.ean}}
    </td>
    <td>
      {{order_entry.order_item.sku}}
    </td>
    <td>
      {{order_entry.order_item.quantity}}
    </td>
    <td>
      <span v-if="order_entry.taxfree == 0">JA</span>
      <span v-if="order_entry.taxfree == 1">NEIN</span>
    </td>
    <td>
      <div style="float:right">{{order_entry.order_item.price_netto}}</div>
    </td>
    <td>
      <div style="float:right">{{order_entry.order_item.price_brutto}}</div>
    </td>
    <td>
      <div style="float:right">{{sumPriceNetto}}</div>
    </td>
    <td>
      <div style="float:right">{{sumPriceBrutto}}</div>
    </td>
  </tr>
</template>

<script>
export default {
  name: 'OrderRow',
  props: ['order_entry'],
  computed: {
    sumPriceNetto() {
      return this.order_entry.order_item.quantity * this.order_entry.order_item.price_netto
    },
    sumPriceBrutto() {
      return this.order_entry.order_item.quantity * this.order_entry.order_item.price_brutto
    },
    margin(){
      var tSumBrutto = this.order_entry.order_item.quantity * this.order_entry.order_item.price_netto;
      return ((tSumBrutto / 100.0) * this.order_entry.margin_percentage).toFixed(2);
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/OpenOrderRow.vue